import { useEffect, useState } from "react";
import { getDashboardSummary, getDashboardCommandCenter, getDashboardAlerts } from "@v0y4ge/api-client";
import type { DashboardSummaryResponse, DashboardCommandCenterResponse, DashboardAlertsResponse } from "@v0y4ge/api-contracts";

const BASE = (import.meta as { env?: Record<string, string> }).env?.VITE_API_URL ?? "http://localhost:8787";

export interface DashboardState {
  summary: DashboardSummaryResponse | null;
  commandCenter: DashboardCommandCenterResponse | null;
  alerts: DashboardAlertsResponse | null;
  loading: boolean;
  error: string | null;
}

export function useDashboard(): DashboardState & { reload: () => void } {
  const [state, setState] = useState<DashboardState>({ summary: null, commandCenter: null, alerts: null, loading: true, error: null });
  const [nonce, setNonce] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    const opts = { baseUrl: BASE };
    Promise.all([
      getDashboardSummary(opts),
      getDashboardCommandCenter(opts),
      getDashboardAlerts(opts),
    ]).then(([summary, commandCenter, alerts]) => {
      if (!cancelled) setState({ summary, commandCenter, alerts, loading: false, error: null });
    }).catch((e: unknown) => {
      if (!cancelled) setState({ summary: null, commandCenter: null, alerts: null, loading: false, error: e instanceof Error ? e.message : "Failed to load dashboard." });
    });
    return () => { cancelled = true; };
  }, [nonce]);
  return { ...state, reload: () => setNonce((n) => n + 1) };
}
